import { Breadcrumbs } from '@shared/components/navigation/Breadcrumbs';
import { HeaderActions } from '@shared/components/navigation/HeaderActions';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { HeaderAction } from '@shared/components/navigation/types';
import { Badge } from '@shared/components/ui/badge';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type EditorMode = 'create' | 'edit';

interface PresetRuleEditorBreadcrumbProps {
  mode: EditorMode;
  presetName: string;
  headerActions?: HeaderAction[];
}

/**
 * Migas de pan para la pantalla de edición de preset (reutiliza el editor de reglas de envío).
 */
export const PresetRuleEditorBreadcrumb = ({
  mode,
  presetName,
  headerActions = [],
}: PresetRuleEditorBreadcrumbProps) => {
  const { t } = useTranslation('shippingRulePresetsModule');

  const breadcrumbs = useMemo(
    () => [
      { label: t('title'), path: '/configuration/shipping-rule-presets', _key: 'shipping-rule-presets-root' },
      {
        label:
          mode === 'create' ? (
            t('editor.breadcrumb-create')
          ) : (
            <span className="inline-flex items-center gap-2">
              <span>{presetName.trim() || '...'}</span>
              <Badge variant="outline" className="text-xs bg-card-border border-0 text-text">
                {t('editor.badge-editing')}
              </Badge>
            </span>
          ),
        _key: `shipping-rule-presets-editor-${mode}-${presetName.trim() || 'empty'}`,
      },
    ],
    [t, mode, presetName],
  );

  usePageNavigation({ breadcrumbs });

  return (
    <div className="flex justify-between gap-4">
      <div className="min-w-0 flex items-center">
        <Breadcrumbs items={breadcrumbs} />
      </div>
      {headerActions.length > 0 ? (
        <div className="flex shrink-0 items-center">
          <HeaderActions actions={headerActions} />
        </div>
      ) : null}
    </div>
  );
};
